<a (click)="toggleFlyout()"><i class="fa fa-upload fa-2x" aria-hidden="true"></i><span>IMPORT VALUES</span></a>
<ng-template cdk-portal>
	<div class="linq-drawer-content">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">{{ header }}</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="closeFlyout()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<form (ngSubmit)="importForm.valid && import()" #importForm="ngForm" name="importValuesCsv" class="linq-drawer-form-content">
			<div class="linq-drawer-inner-content">
				<div class="flyout-inner-container linq-drawer-inner-content--spaced">

					<div class="row">
						<div class="col-xs-12 linq-mb-5">
							<span>
								You may import multiple Budget Balances at a time by uploading a CSV file.
								The CSV file must be formatted in the following way...
							</span>
						</div>
						<div class="col-xs-12">
							<div class="middle-display-container">
								<table aria-label="Accounts" class="table-bordered">
									<tr>
										<th>
											&nbsp; Account # &nbsp;
										</th>
										<th>
											&nbsp; Budget Total &nbsp;
										</th>
									</tr>
									<tr>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
									</tr>
									<tr>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
									</tr>
								</table>
								<sl-file-upload [allowedExtensions]="validExtensions" [maxSize]="maxSize" [readAsText]="true"
									(fileUploaded)="fileUploaded($event)"
									[uploadedFile]="{ fileName: uploadedFile.fileName, fileBase64Encoded: uploadedFile.fileBase64Encoded }"
									class="importfile-uploader"></sl-file-upload>
							</div>
						</div>
						<div *ngIf="uploadedFile.fileBase64Encoded" class="col-xs-12 linq-mt-8 error">*Imported budget values will overwrite existing
							account values.</div>
					</div>
				</div>
			</div>
			<footer class="linq-drawer-footer">
				<button type="button" mat-stroked-button color="primary" class="linq-button--secondary" (click)="closeFlyout()">Cancel</button>
			</footer>
		</form>
	</div>
</ng-template>